export const DRSceanrioProjectDataCreating = (data, prevProject) => {
  const projectValues = Object.values(data);
  const {id,dealroom_project} = prevProject;
  const user_project_asset = prevProject.scenario_project_asset ? prevProject.scenario_project_asset : prevProject.user_project_asset;
  const user_project_contracts = prevProject.scenario_project_contracts ? prevProject.scenario_project_contracts : prevProject.user_project_contracts;
  const user_project_epc = prevProject.scenario_project_epc ? prevProject.scenario_project_epc : prevProject.user_project_epc;
  let count = 5;

  const result = {
    name: data.pname.slice(8, data.pname.length),
    dealroom_project: dealroom_project ? dealroom_project : id,
    asset: {
      data: {},
      additional_fields: {},
      asset_schema_id: user_project_asset.asset_schema_id,
    },
    contracts: [],
    epc: {
      data: {},
      additional_fields: {},
      epc_schema_id: user_project_epc.epc_schema_id,
    },
    // user_project: prevProject.id
  };

  // assets data set start
  const assetData = user_project_asset.data;

  Object.keys(assetData).map((key, i) => {
    if (assetData[key].type === 'integer' || assetData[key].type === 'number') {
      result.asset.data[key] = +projectValues[i + count];
    } else if (assetData[key].type === 'string') {
      result.asset.data[key] = projectValues[i + count] + '';
    } else if (assetData[key].type === 'object') {
      result.asset.data[key] = projectValues[i + count];

    }
    result.asset.additional_fields[key] = {
      source: projectValues[5][0] && key !== 'pname' && projectValues[5][0][key + 0] || '',
      verifier: projectValues[5][2] && key !== 'pname' && projectValues[5][2][key + 0] || '',
      tied_document: Boolean(projectValues[5][1] && key !== 'pname' && projectValues[5][1][key + 0])
    }
  });
  // assets data set end

  count += Object.keys(user_project_asset.data).length;

  // contracts data set start
  result.contracts = user_project_contracts.length > 0
    && user_project_contracts.map((contract, i) => {
      const contractObj = {
        data: {},
        additional_fields: {},
        contract_schema_id: contract.contract_schema_id,
      };
      Object.keys(contract.data).map((key) => {
        if (contract.data[key].type === 'integer' || contract.data[key].type === 'number') {
          contractObj.data[key] = +projectValues[count];
        } else if (contract.data[key].type === 'boolean') {
          contractObj.data[key] = Boolean(projectValues[count]);
        } else if (contract.data[key].type === 'string') {
          contractObj.data[key] = projectValues[count] + '';
        }
        contractObj.additional_fields[key] = {
          source: projectValues[5][0] && projectValues[5][0][key + (1 + i)] || '',
          verifier: projectValues[5][2] && projectValues[5][2][key + (1 + i)] || '',
          tied_document: Boolean(projectValues[5][1] && projectValues[5][1][key + (1 + i)])
        };
        count += 1;
      });
      return contractObj;
    }) || [];
  // contracts data set end

  const length = user_project_contracts.length;

  // epc data set start
  const epcData = user_project_epc.data;
  Object.keys(epcData).map((key, i) => {

    if (epcData[key].type === 'boolean') {
      result.epc.data[key] = Boolean(projectValues[count + i]);
    } else if (epcData[key].type === 'integer' || epcData[key].type === 'number') {
      result.epc.data[key] = +projectValues[count + i];
    } else if (epcData[key].hasOwnProperty('list')) {
      result.epc.data[key] = projectValues[count + i];
      // valueSplit(projectValues[4][0][count + i]);
    } else {
      result.epc.data[key] = projectValues[count + i];
    }

    result.epc.additional_fields[key] = {
      source: projectValues[5][0] && projectValues[5][0][key + (1 + length)] || '',
      verifier: projectValues[5][2] && projectValues[5][2][key + (1 + length)] || '',
      tied_document: Boolean(projectValues[5][1] && projectValues[5][1][key + (1 + length)])
    };


  });
  // epc data set end

  return result;
};


// WEBPACK FOOTER //
// ./src/views/Dealroom/Dealroom/ScenarioProjects/helpers.js